import { render, staticRenderFns } from "./m-main-navigation.vue?vue&type=template&id=700f19d0&scoped=true&"
import script from "./m-main-navigation.vue?vue&type=script&lang=js&"
export * from "./m-main-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f19d0",
  null
  
)

export default component.exports